module.exports = __webpack_public_path__ + "static/media/26.7b0de216.JPG";